import { List, ListItem, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { APP_ROUTES } from "../../routes";
import { t } from "i18next";

const Navlinks = () => {
  const { pathname } = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const style = {
    listItem: {
      position: "relative",
      px: 0,
      "&::after": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        height: "2px",
        backgroundColor: "#ffffff",
        transition: "width 0.3s ease-in-out",
        width: "0%",
      },
      "&:hover::after": {
        width: "100%",
      },
    },
    link: {
      color: "#ffffff",
      textDecoration: "none",
      fontSize: "0.875rem",
      fontFamily: "Roboto",
      textTransform: "capitalize",
    },
    popoverlink: {
      color: "#000000",
      textDecoration: "none",
      fontSize: "0.875rem",
      fontFamily: "Roboto",
      textTransform: "capitalize",
    },
  };

  return (
    <List
      sx={{
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        whiteSpace: "nowrap",
        gap: 2,
      }}
    >
      {APP_ROUTES.map((val, ind) => {
        if (val.name === "allServices") {
          return (
            <ListItem
              key={ind}
              sx={{
                ...style.listItem,
                "&::after": {
                  ...style.listItem["&::after"],
                  width: pathname === val.path ? "100%" : "0",
                },
              }}
              onClick={handlePopoverClick}
            >
              <Typography style={{ ...style.link, cursor: "pointer" }}>
                {t(val.name)}
              </Typography>
              <Popover
                id="click-popover"
                sx={{
                  pointerEvents: "auto",
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
              >
                <List>
                  <ListItem>
                    <Link to="/" style={style.popoverlink}>
                      {t("eCommerce")}
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link to="/cleaning-services" style={style.popoverlink}>
                      {t("cleaning")}
                    </Link>
                  </ListItem>
                  <ListItem>
                    <Link to="/car-services" style={style.popoverlink}>
                      {t("carService")}
                    </Link>
                  </ListItem>
                </List>
              </Popover>
            </ListItem>
          );
        }
        return (
          <ListItem
            key={ind}
            sx={{
              ...style.listItem,
              "&::after": {
                ...style.listItem["&::after"],
                width: pathname === val.path ? "100%" : "0",
              },
            }}
          >
            {val.name === "becomePartner" ? (
              <a
                style={style.link}
                href={"https://portal.eaziday.com/"}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(val.name)}
              </a>
            ) : (
              <Link style={style.link} to={val.path}>
                {t(val.name)}
              </Link>
            )}
          </ListItem>
        );
      })}
    </List>
  );
};

export default Navlinks;
